import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "customRangeStartGroup", 
    "customRangeEndGroup", 
    "specificDayGroup", 
    "specificMonthGroup", 
    "specificYearGroup"
  ]

  connect() {
    this.toggleDateFields() // Call on page load to set initial state
  }

  toggleDateFields(event) {
    let selectedPeriodType
    if (event) {
      selectedPeriodType = event.target.value
    } else {
      // On initial load, get value from the select tag directly
      const periodSelect = this.element.querySelector("#period_type") // Assuming your select_tag has id="period_type"
      if (periodSelect) {
        selectedPeriodType = periodSelect.value
      }
    }
    
    this.hideAllDateFieldGroups()

    switch (selectedPeriodType) {
      case "custom_range":
        this.customRangeStartGroupTarget.style.display = "block"
        this.customRangeEndGroupTarget.style.display = "block"
        break
      case "specific_day":
        this.specificDayGroupTarget.style.display = "block"
        break
      case "specific_month":
        this.specificMonthGroupTarget.style.display = "block"
        break
      case "specific_year":
        this.specificYearGroupTarget.style.display = "block"
        break
      // For "Today", "This Month", "This Year", etc., no extra date fields are needed
      // as the controller calculates them based on the period_type.
    }
  }

  hideAllDateFieldGroups() {
    this.customRangeStartGroupTarget.style.display = "none"
    this.customRangeEndGroupTarget.style.display = "none"
    this.specificDayGroupTarget.style.display = "none"
    this.specificMonthGroupTarget.style.display = "none"
    this.specificYearGroupTarget.style.display = "none"
  }
}